import { render, staticRenderFns } from "./Aviso.vue?vue&type=template&id=4bdb56ea&scoped=true&"
import script from "./Aviso.vue?vue&type=script&lang=js&"
export * from "./Aviso.vue?vue&type=script&lang=js&"
import style0 from "./Aviso.vue?vue&type=style&index=0&id=4bdb56ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb56ea",
  null
  
)

export default component.exports